import { render, staticRenderFns } from "./YoungContact.vue?vue&type=template&id=3bc68792&"
import script from "./YoungContact.vue?vue&type=script&lang=js&"
export * from "./YoungContact.vue?vue&type=script&lang=js&"
import style0 from "./YoungContact.vue?vue&type=style&index=0&id=3bc68792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports